// Types.
// -----------------------------------------------------------------------------
// Common.
// -----------------------------------------------------------------------------
// Defined breakpoints.
export const UI_BREAKPOINTS = ['s', 'm', 'l', 'xl', '2xl'];
//# sourceMappingURL=breakpoints.types.js.map